import React, { useState } from 'react'

import {
  Avatar,
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Table,
  Tag,
} from 'antd'
import {
  getAllAppUsers
} from '../../modules/appUser'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { APPUSERS_STATUS } from '../../utils/constants'
import { useDeepEffect } from '../../utils/hooks'
import moment from 'moment';
import Lightbox from "react-image-lightbox";
import "../../../node_modules/react-image-lightbox/style.css";

const GetStatusColor = (status) => {
  let color = ''
  if (status !== null) {
    switch (status.toUpperCase()) {
      case 'ENABLED':
        color = 'green'
        break
      case 'DEACTIVATE':
        color = 'red'
        break
      default:
        break
    }
  }
  return color
}

const initialOptions = {
  page: 0,
  size: 20,
  status: ''
}

const AppUsers = ({ form }) => {
  const { validateFields, getFieldDecorator } = form
  const dispatch = useDispatch()
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [filterOption, setFilterOption] = useState(initialOptions)
  const [current, setCurrent] = useState('')

  const { userList ,isLoading } = useSelector(
    (state) => ({
      userList: state.appUser.userList,
      isLoading: state.appUser.isLoading
    }),
    []
  )

  async function fetch() {
    await dispatch(getAllAppUsers(filterOption))
  }

  useDeepEffect(() => {
    fetch()
  }, [])

  const handleClickImage = (e, image) => {
    e && e.preventDefault();
    setCurrent(image)
  };

  const handleCloseModal = e => {
    e && e.preventDefault();
    setCurrent('')
  };

  const columns = [
    {
      title: 'วันที่สมัคร',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => {
        const created = GetDate(createdAt)
        return (
          <span>
            {created}
          </span>
        )
      }
    },
    {
      title: 'Avatar',
      dataIndex: 'imageUrl',
      key: 'imageUrl',
      width: 80,
      render: (text, record) => (
        <div>
          <Avatar src={text} onClick={e => handleClickImage(e, text)} />
          {current && (
            <Lightbox mainSrc={current} onCloseRequest={handleCloseModal} />
          )}
        </div>
      )
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: 'Tel',
      dataIndex: 'tel',
      key: 'tel',
      render: (text, record) => <span>{text ? text : ''}</span>
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      filters: APPUSERS_STATUS.map((status) => ({
        text: status,
        value: status
      })),
      onFilter: (value, record) => record.status === value,
      render: (status) => {
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag color={color} key={status}>
              {status}
            </Tag>
          </span>
        )
      }
    },
  ]

  async function onShowSizeChange(current, pageSize) {
    filterOption.size = pageSize
    setFilterOption(filterOption)
    await dispatch(getAllAppUsers(filterOption))
  }

  async function onChange(page) {
    filterOption.page = page - 1
    setFilterOption(filterOption)
    await dispatch(getAllAppUsers(filterOption))
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        if (values.status === 'all') {
          filterOption.status = ''
        } else {
          filterOption.status = values.status
        }

        if (values.keyword) {
          filterOption.keyword = '%' + values.keyword + '%'
        } else {
          filterOption.keyword = ''
        }
        filterOption.page = 0
        await dispatch(getAllAppUsers(filterOption))
      }
    })
  }

  async function onClear() {
    filterOption.page = initialOptions.page
    filterOption.size = initialOptions.size
    filterOption.status = ''
    filterOption.keyword = ''
    form.resetFields()
    await dispatch(getAllAppUsers(filterOption))
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys)
    },
    selectedRowKeys: selectedRowKeys
  }
  const GetDate = (created) => {
    let date = ''
    if (created !== null) {
      date = moment(created).add(543, 'years').format('DD/MM/YYYY')
    }
    return date
  }


  return (
    <Card
      title="App Users"
      extra={
        <div>
          <Button size="small" icon="reload" onClick={() => fetch()}>
            Reload
          </Button>
        </div>
      }>
          <Form onSubmit={onSubmit} layout="inline">
            <Row type="flex" justify="space-between" align="middle">
              <Col>
                <Row type="flex" justify="end" gutter={8} align="middle">
                  <Col>
                    <Form.Item style={{ margin: 0 }}>
                      {getFieldDecorator(`keyword`)(
                        <Input
                          style={{ width: 200 }}
                          placeholder="Email,Name,Tel"
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item style={{ margin: 0 }} label="สถานะ">
                      {getFieldDecorator(`status`, {
                        initialValue: 'all'
                      })(
                        <Select style={{ width: 150 }}>
                          <Select.Option value="all">ทั้งหมด</Select.Option>
                          {APPUSERS_STATUS.map((type) => {
                            return (
                              <Select.Option key={type} value={type}>
                                {type}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col>
                    <Button type="primary" htmlType="submit">
                      ค้นหา
                    </Button>
                  </Col>
                  <Col>
                    <Button type="danger" onClick={() => onClear()}>
                      เคลียร์
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
          {!isEmpty(userList) && (
            <Table
              bordered
              loading={isLoading}
              scroll={{ x: 700 }}
              rowKey={(record) => record.id}
              dataSource={userList.content}
              columns={columns}
              pagination={{
                current: userList.pageable.pageNumber + 1,
                pageSize: userList.size,
                pageSizeOptions: ['10', '20', '50', '100'],
                showSizeChanger: true,
                onShowSizeChange: onShowSizeChange,
                onChange: onChange,
                total: userList.totalElements
              }}
            />
          )}
    </Card>
  )
}

const WrappedAppUsers = Form.create({ name: 'AppUsers' })(AppUsers)
export default WrappedAppUsers
